import React, {Component} from 'react'
import PropTypes from "prop-types";

export default class DataGridRowCell extends Component {
    static propTypes = {
        /**
         * colspan attribute to wrapper (td tag)
         * (this value will be set automatically by the parent component (DataGridRow),
         * do not change this value if you are not sure what you are doing)
         */
        colSpan: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
        /**
         *  styles width value
         */
        width: PropTypes.string,
        /**
         * data label attribute (for mobile devices)
         * (this value will be set automatically by the parent component (DataGridRow),
         * do not change this value if you are not sure what you are doing)
         */
        dataLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        /**
         *  Component inner (can be anything)
         */
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ])
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {
            children,
            colSpan,
            width,
            dataLabel,
            style,
            ...rest
        } = this.props;

        const attrs = {
            colSpan: colSpan ? colSpan : null,
            ...rest
        };

        const styles = {
            ...style,
            width: width ? width : null
        };

        return (
            <td {...attrs} style={styles} data-label={dataLabel || ""}>
                {children}
            </td>
        )
    }
}
